/* REACT */
import React, { useMemo, useState, useEffect } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'
import moment from 'moment'
import 'moment/locale/nl'

/* COMPONENTS */
import Rating from '../../../ui/rating/rating'

/* STORE */
import { setIsPopoverChatOpen } from '../../../../store/general/actions'

/* STYLES */
import {
  ItemImageWrapper,
  ItemImage,
  Title,
  LabelBottomWrapper,
  LabelBottom,
  RatingImage,
  RatingImageWrapper,
  TitleWrapper,
  GridItemWrapper,
  TripTypeWrapper,
  TripTypeOnImage,
  TripTypeOnCard,
  TripDetailsWrapper,
  TripSecondaryDetailsWrapper,
  TripSecondaryDetailsItemWrapper,
  RelevancyInfo,
  GridItemDetailsWrapper,
  TripSecondaryDetails,
  Location,
  TripInfoTitle,
  TripInfoWrapper,
  TripInfo,
  TripInfoItem,
  TripInfoAvailibility,
  Keywords,
  Description,
} from './style'

/* UTILS/CONSTANTS*/
import {
  CLOUDFRONT_BASE_URL,
  TRIP_AVAILIBILITY_STATUSES,
} from '../../../../utils/constants'
import { Analytics, getTranslations } from '../../../../utils'
import { logAction } from '../../../../utils/actionLogger'

/*ASSETS*/
const NoImage = `${CLOUDFRONT_BASE_URL}/assets/images/NoImage.png`
const PinImage = `${CLOUDFRONT_BASE_URL}/assets/icons/Pin.svg`

const TripItem = ({
  index,
  isLessThanLaptop,
  item,
  router,
  language,
  setIsPopoverChatOpen,
  key,
  openPopoverChatOnClickthrough,
  showRelevancyInfo,
  randomMatch,
  itemsPerRow,
  organizationDetails,
}) => {
  // SET MOMENT LOCALE TO CURRENT LANGUAGE
  moment.locale(language)

  const {
    name,
    images,
    price,
    destinations,
    label_image,
    duration,
    trip_info,
    label_card,
    rating_image,
    keywords,
    rating_value,
    rating_total_value,
    description,
    label_bottom,
  } = item

  const [tripPrice, setTripPrice] = useState(price)
  const [earlyBookingTripPrice, setEarlyBookingTripPrice] = useState(null)
  const [keywordsText, setKeywordsText] = useState(null)
  const [durationInDays, setDurationInDays] = useState(duration)

  const itemImage = images?.length ? images[0]?.url : NoImage

  const mouseDownCoords = e => {
    window.checkForDrag = e.clientX
  }

  const setWidthOfNameDiv = () => {
    // IF THERE IS LABEL CARD THEN ADJUST WIDTH OF NAME DIV
    const labelCardDiv = document.getElementById(`trip-label-card-${index}`)
    if (!labelCardDiv) {
      return
    }

    const mainDiv = document.getElementById(
      `grid-item-details-wrapper-${index}`
    )
    const nameDiv = document.getElementById(`trip-title-wrapper-${index}`)

    if (nameDiv && mainDiv) {
      // ADD 20PX FOR THE PADDING
      nameDiv.style.width = `${
        mainDiv.offsetWidth - labelCardDiv.offsetWidth - 20
      }px`
    }
  }

  useEffect(() => {
    setWidthOfNameDiv()
  }, [key, index])

  useEffect(() => {
    // SET TRIP PRICE
    if (item?.trip_info?.length) {
      for (let info of item.trip_info) {
        if (info?.selling_price) {
          // SET PRICE IF NOT SET
          setTripPrice(info.selling_price)

          if (info?.duration_in_days && !duration) {
            // SET DURATION IF NOT SET
            setDurationInDays(info.duration_in_days)
          }

          if (info?.early_booking_price) {
            // SET EARLY BOOKING PRICE
            setEarlyBookingTripPrice(info.early_booking_price)
          }

          break
        }
      }
    }

    if (keywords?.length) {
      let keywordsString = ''
      for (let keyword of keywords) {
        if (keywordsString.length > 0) keywordsString += ' | '
        keywordsString += `${keyword}`
      }

      setKeywordsText(keywordsString)
    }
  }, [key])

  const hasTripAvailibilityInfo = useMemo(() => {
    if (item?.trip_info?.length) {
      let hasTripAvailibilityInfo = false
      for (let info of item.trip_info) {
        if (info?.departure_date && info?.travel_availability_status) {
          hasTripAvailibilityInfo = true
          break
        }
      }
      return hasTripAvailibilityInfo
    }
    return false
  }, [key])

  const getAvailibiltyColor = status => {
    if (
      TRIP_AVAILIBILITY_STATUSES.available.find(element => {
        return element.toLowerCase() === status.toLowerCase()
      })
    ) {
      return 'green'
    }

    if (
      TRIP_AVAILIBILITY_STATUSES.full.find(element => {
        return element.toLowerCase() === status.toLowerCase()
      }) ||
      TRIP_AVAILIBILITY_STATUSES.cancelled.find(element => {
        return element.toLowerCase() === status.toLowerCase()
      })
    ) {
      return 'red'
    }

    if (
      TRIP_AVAILIBILITY_STATUSES.guaranteed.find(element => {
        return element.toLowerCase() === status.toLowerCase()
      }) ||
      TRIP_AVAILIBILITY_STATUSES.nearly_full.find(element => {
        return element.toLowerCase() === status.toLowerCase()
      })
    ) {
      return 'orange'
    }
  }

  const getRelevancyColor = () => {
    if (randomMatch) {
      return 'orange'
    }

    return 'green'
  }

  const destinationsText = useMemo(() => {
    if (destinations?.length) {
      let text = ''
      let index = 0
      for (let destination of destinations) {
        if (index) {
          text += `, `
        }
        text += `${destination}`
        index += 1
      }
      return text
    }
    return ''
  }, [destinations])

  if (!organizationDetails?.slug) {
    return null
  }

  return (
    <GridItemWrapper
      target={
        organizationDetails?.openNewTabOnClickthroughGrid ? '_blank' : '_self'
      }
      href={item.url}
      onClick={() => {
        Analytics.getInstance().sendEvent('maya_click_grid_item', {
          item_entity: 'trips',
          item_title: name,
          item_subtitle: tripPrice,
          item_type: label_image,
          item_destination: destinations[0],
          item_url: item.url,
        })
        logAction({
          name: 'url_click_grid',
          url: item.url,
          linkLabel: name,
        })
        if (openPopoverChatOnClickthrough) {
          setIsPopoverChatOpen(true)
        }
      }}
      itemsPerRow={itemsPerRow}
    >
      <GridItemDetailsWrapper id={`grid-item-details-wrapper-${index}`}>
        <ItemImageWrapper onMouseDown={e => mouseDownCoords(e)}>
          <ItemImage index={index} backgroundImage={itemImage}>
            {label_image ? (
              <TripTypeWrapper>
                <TripTypeOnImage>{label_image}</TripTypeOnImage>
              </TripTypeWrapper>
            ) : null}
          </ItemImage>
        </ItemImageWrapper>
        <TripDetailsWrapper>
          {label_card ? (
            <TripTypeWrapper>
              <TripTypeOnCard id={`trip-label-card-${index}`}>
                {label_card}
              </TripTypeOnCard>
            </TripTypeWrapper>
          ) : null}

          {name || tripPrice || durationInDays ? (
            <TripSecondaryDetailsWrapper>
              {randomMatch && showRelevancyInfo ? (
                <RelevancyInfo
                  style={{
                    backgroundColor: getRelevancyColor(),
                  }}
                >
                  {getTranslations('relevancy_info.partial_match')}
                </RelevancyInfo>
              ) : null}
              {destinations?.length && name ? (
                <>
                  <TitleWrapper
                    id={`trip-title-wrapper-${index}`}
                    style={{ paddingBottom: '0px' }}
                  >
                    {destinations?.length ? (
                      <Location>{destinationsText}</Location>
                    ) : null}
                  </TitleWrapper>
                  <TitleWrapper>
                    <Title dangerouslySetInnerHTML={{ __html: name }}>
                      {/* {name} */}
                    </Title>
                  </TitleWrapper>
                </>
              ) : name || destinations?.length ? (
                <TitleWrapper id={`trip-title-wrapper-${index}`}>
                  {destinations?.length ? (
                    <Location>{destinationsText}</Location>
                  ) : null}
                  <Title>{name}</Title>
                </TitleWrapper>
              ) : null}

              {rating_image ? (
                <RatingImageWrapper>
                  <RatingImage src={rating_image} alt='rating' />
                </RatingImageWrapper>
              ) : null}
              {keywordsText ? (
                <TitleWrapper>
                  <Keywords>{keywordsText}</Keywords>
                </TitleWrapper>
              ) : null}
              {tripPrice || durationInDays ? (
                <TripSecondaryDetailsItemWrapper>
                  {' '}
                  {tripPrice && !earlyBookingTripPrice ? (
                    <TripSecondaryDetails>{`${durationInDays} ${`${
                      durationInDays ? ` - ${tripPrice}` : tripPrice
                    }`}`}</TripSecondaryDetails>
                  ) : (
                    <>
                      {tripPrice || earlyBookingTripPrice ? (
                        <>
                          <TripSecondaryDetails>{`${
                            durationInDays ? ` - ` : ''
                          }`}</TripSecondaryDetails>
                          <TripSecondaryDetails
                            style={{ textDecoration: 'line-through' }}
                          >
                            {`${tripPrice}`}
                          </TripSecondaryDetails>

                          <TripSecondaryDetails>
                            {earlyBookingTripPrice}
                          </TripSecondaryDetails>
                        </>
                      ) : null}
                    </>
                  )}
                </TripSecondaryDetailsItemWrapper>
              ) : null}

              {label_bottom ? (
                <LabelBottomWrapper>
                  <LabelBottom>{label_bottom}</LabelBottom>
                </LabelBottomWrapper>
              ) : null}

              {rating_value && rating_total_value ? (
                <Rating
                  title={getTranslations('reviews')}
                  value={rating_value}
                  total={rating_total_value}
                />
              ) : null}
              {description ? (
                <Description>
                  {description?.length > 100
                    ? `${description.substring(0, 100)}...`
                    : description}
                </Description>
              ) : null}
            </TripSecondaryDetailsWrapper>
          ) : null}
        </TripDetailsWrapper>
        {hasTripAvailibilityInfo ? (
          <>
            <TripInfoWrapper>
              <TripInfoTitle>
                {getTranslations('departure_dates')}
              </TripInfoTitle>
              {trip_info?.map((info, i) => {
                return (
                  <>
                    {info?.departure_date ? (
                      // ONLY SHOW IF CONTENT IS THERE
                      <TripInfo>
                        <TripInfoItem>
                          {moment(info.departure_date, 'YYYY-MM-DD').format(
                            'D MMM YYYY'
                          )}
                        </TripInfoItem>
                        <TripInfoAvailibility
                          style={{
                            color: getAvailibiltyColor(
                              info.travel_availability_status
                            ),
                            border: `1px solid ${getAvailibiltyColor(
                              info.travel_availability_status
                            )}`,
                          }}
                        >
                          {info.travel_availability_status}
                        </TripInfoAvailibility>
                      </TripInfo>
                    ) : null}
                  </>
                )
              })}
            </TripInfoWrapper>
          </>
        ) : null}
      </GridItemDetailsWrapper>
    </GridItemWrapper>
  )
}

const mapStateToProps = state => ({
  openPopoverChatOnClickthrough: state?.general?.openPopoverChatOnClickthrough,
  organizationDetails: state?.maya?.organizationDetails,
})

const mapDispatchToProps = dispatch => ({
  setIsPopoverChatOpen: isOpen => dispatch(setIsPopoverChatOpen(isOpen)),
})

export default connect(mapStateToProps, mapDispatchToProps)(TripItem)
